import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const NewsBulletin = () => {
  const t = useT();
  const [duration, setDuration]     = useState('15 min');
  const [storyCount, setStoryCount] = useState('8');

  return (
    <GenPage
      title={t('page.newsBulletin.title')}
      contentType="newsBulletin"
      description={t('page.newsBulletin.desc')}
      outputLabel={t('page.newsBulletin.output')}
      extraOptions={
        <>
          <div className="flex items-center gap-1.5">
            <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.duration')}</span>
            <SegmentControl
              options={['5 min', '10 min', '15 min', '30 min']}
              value={duration}
              onChange={setDuration}
            />
          </div>
          <div className="h-5 w-px bg-gray-200 mx-1" />
          <div className="flex items-center gap-1.5">
            <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.stories')}</span>
            <SegmentControl
              options={['5', '8', '10', '15']}
              value={storyCount}
              onChange={setStoryCount}
            />
          </div>
        </>
      }
      extraInstructions={`Bulletin duration: ${duration}\nNumber of stories to include: ${storyCount}`}
    />
  );
};
